import { createRouter, createWebHistory } from 'vue-router'

import { isAuthenticated } from '@/libs/auth'
import { useAppStore } from '@/stores/app'

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition)         return savedPosition
        if (from.path === to.path) return {}

        return { top: 0, behavior: 'smooth' }
    },
    routes: [
        {
            path:     '/',
            redirect: '/todos',
        },
        {
            path:      '/login',
            name:      'login',
            component: () => import('@/views/Login.vue'),
            meta:      { layout: 'Blank', requiresAuth: false },
        },
        {
            path:      '/todos',
            name:      'todos',
            component: () => import('@/views/todo/Todos.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/settings',
            name:      'settings',
            component: () => import('@/views/Settings.vue'),
            meta:      { requiresAuth: true },
        },
    ],
})

router.beforeEach((to, from, next) => {
    const appStore = useAppStore()
    const loggedIn = isAuthenticated()

    if (loggedIn && to.name === 'login') return next({ name: 'todos' })

    if (to.meta.requiresAuth && !loggedIn) {
        appStore.setLogout()

        return next({ name: 'login' })
    }

    next()
})

export default router
